import { Injectable } from '@angular/core';

import { SiteTypeEnum } from '../../enums';
import { QuickRepliesElementsConfiguration } from '../../models';
import { StrategyAbstractService } from '../strategy-abstract.service';

@Injectable({
  providedIn: 'root',
})
export class LineService extends StrategyAbstractService {
  constructor() {
    super();
  }

  getType(): number {
    return 16;
  }
  getTypeString(): string {
    return SiteTypeEnum.Line;
  }
  getAllTasksTypes(): number[] {
    return [44];
  }
  getPrivateTaskTypes(): number[] {
    return [44];
  }
  getTaskTypeString(taskType: number): string {
    const mapping = {
      44: 'line/msg',
    };
    return mapping[taskType];
  }
  getTaskTypeQueueId(taskType: number): string {
    const mapping = {
      44: 'line-msg',
    };
    return mapping[taskType];
  }

  canHaveSurveys(): boolean {
    return false;
  }

  getQuickRepliesElementsConfig(): QuickRepliesElementsConfiguration {
    return {
      maxAnswerNb: 13,
      answerLabelMaxLength: 20,
      hasDescription: false,
      canHaveUserVariableInRootQuestion: true,
      hasPhoneEmailAnswerType: false,
      hasUrlAnswerType: false,
      hasTargetAppId: false,
      boxesCanBeTested: false,
      hasPersistentMenu: false,
      hasWelcomeMessage: false,
      imageMimeTypes: 'image/jpeg,image/png',
      editorConfiguration: {
        fileEnabled: false,
        hasImageControl: false,
      },
      sendTextAfterButtonChoice: false,
      canSendVideo: true,
      getStartedBoxCannotDisableUserInput: true,
    };
  }
}
